import { WEEKDAYS } from "@typings/globals";
import { NonStandardFrequencyShifts, B2B_SHIFTS } from "@typings/b2b";
import { NonStandardFrequencyShifts as B2CNonStandardFrequencyShifts } from "@typings/booking";
interface NonStandardFrequencyShiftsTranslations {
  [WEEKDAYS.MON]: string;
  [WEEKDAYS.TUE]: string;
  [WEEKDAYS.WED]: string;
  [WEEKDAYS.THU]: string;
  [WEEKDAYS.FRI]: string;
  [WEEKDAYS.SAT]: string;
  [WEEKDAYS.SUN]?: string;
  hoursText: string;
  hourText: string;
}

interface B2BNonStandardFrequencyShiftsTranslations
  extends NonStandardFrequencyShiftsTranslations {
  [B2B_SHIFTS.FROM_FIVE_TO_EIGHT]: string;
  [B2B_SHIFTS.FROM_EIGHT_TO_EIGHTEEN]: string;
  [B2B_SHIFTS.FROM_EIGHTEEN_TO_TWENTY_THREE]: string;
}

const getDurationTranslated = (
  duration: number,
  translations: NonStandardFrequencyShiftsTranslations,
) => {
  const hoursTranslation =
    duration > 1 ? translations.hoursText : translations.hourText;

  return `${duration} ${hoursTranslation}`;
};

export const formatNonStandardFrequencyShiftsToHumanReadable = (
  nonStandardFrequencyShifts: NonStandardFrequencyShifts[],
  nonStandardFrequencyShiftsTranslations: B2BNonStandardFrequencyShiftsTranslations,
): string[] =>
  nonStandardFrequencyShifts.map(shift => {
    const weekdayTranslated =
      nonStandardFrequencyShiftsTranslations[shift.dayOfWeek];
    const shiftTranslated = nonStandardFrequencyShiftsTranslations[shift.shift];
    const durationTranslated = getDurationTranslated(
      shift.duration,
      nonStandardFrequencyShiftsTranslations,
    );

    return `${weekdayTranslated} ${shiftTranslated}, ${durationTranslated}`;
  });

export const formatB2CNonStandardFrequencyShiftsToHumanReadable = (
  nonStandardFrequencyShifts: B2CNonStandardFrequencyShifts[],
  nonStandardFrequencyShiftsTranslations: NonStandardFrequencyShiftsTranslations,
): string[] =>
  nonStandardFrequencyShifts.map(shift => {
    const weekdayTranslated =
      nonStandardFrequencyShiftsTranslations[shift.dayOfWeek];
    const durationTranslated = getDurationTranslated(
      shift.duration,
      nonStandardFrequencyShiftsTranslations,
    );

    return `${weekdayTranslated} ${shift.shift}, ${durationTranslated}`;
  });
